export default __webpack_public_path__ + "svg/CompaniesLogos/logo_igeneris.svg?4f19e6f4";